<ng-container *transloco="let t">
  <app-page-template>
    <section class="upper-section py-5 px-4">
      <div class="upper-section-background image-fade-in" [@fadeInAnimation]="'in'"></div>
      <div class="d-block d-md-flex justify-content-center align-items-center">
        <div>
          <app-form-card>
            <ng-container [ngSwitch]="signupVerificationComponentState">
              <div *ngSwitchDefault>
                <app-alert-error/>
                <h2 class="text-center">{{t('signup.verification.error')}}</h2>
                <div class="separator my-5"></div>
                <app-button [label]="t('app.common.go.back')" (onClick)=" onGoToSignUp()"
                            [btnClass]="'btn-primary-red btn-large'"/>
              </div>
              <div *ngSwitchCase="signupVerificationComponentStateType.INITIAL">
                <app-alert-warning/>
                <h2 class="text-center">{{t('signup.verification')}}</h2>
              </div>
              <div *ngSwitchCase="signupVerificationComponentStateType.SUCCESS">
                <app-alert-success/>
                <h2 class="text-center">{{t('signup.verification.success')}}</h2>
                <p class="text-center pt-3">{{t('signup.verification.login.to.continue')}}</p>
                <div class="separator my-5"></div>
                <app-button [label]="t('signup.verification.go.to.login')"
                            [btnClass]="'btn-primary-red btn-large'" (onClick)="onGoToLogin()"/>
              </div>
            </ng-container>
          </app-form-card>
        </div>
      </div>
    </section>
  </app-page-template>
</ng-container>
